module.exports = __webpack_public_path__ + "static/media/pattern-stretch.94a25067.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/patterns/pattern-stretch.svg
// module id = 1266
// module chunks = 37